<template>
  <div class="test-container">
    <!-- 操作 -->
    <div style="overflow:hidden">
      <div>
        <span class="title">参数配置</span>
        <div style="display:inline-block;float:right">
          <el-button
            type="primary"
            @click="add"
          >新增参数</el-button>
        </div>

      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @cell-mouse-enter="operateShow"
      @cell-mouse-leave="operateClose"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        fixed
        label="序号"
        min-width="100px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sortNum }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="Key值"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.paramKey) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="value"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.value) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="备注"
        min-width="100px"
      >
        <template slot-scope="scope">{{ scope.row.remark }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        width="150px"
      >
        <template
          slot-scope="scope"
          class="icon"
        >
          <div class="icon">
            <i
              class="el-icon-change"
              @click="editRole(scope.row)"
            />
            <i
              class="el-icon-dele"
              @click="delet(scope.row.id)"
            />
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-sizes="pageInfo.pageSizeList"
        :page-size="pageInfo.limit"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <template>
      <div v-if="isShowEdit">
        <EditDialog
          :editData="currentData"
          :isedit="isedit"
          @handleclose="closeDialog"
          @refresh="getRoleList"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { paramList, deleteParam, systemDetail, getSystem } from '@/api/system'
import EditDialog from './editDialog'
import { statusTrans, emptyTrans, sortDataList } from '@/api/dataTrans.js'
export default {
  components: { EditDialog },
  data () {
    return {
      list: [],
      listLoading: true,
      isShowEdit: false,
      isShowAdd: false,
      isedit: false,
      currentData: {},
      tableKey: 0,
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      businessList: [],
      flag: false,
      type: 0,
      title: '添加角色',
      parmas: null,
      id: null,
      appIds: null,
      roleId: null,
      nameList: []
    }
  },
  mounted () {
    //获取列表数据
    this.getRoleList()
    // this.getSystemName()
  },

  methods: {
    getRoleList () {
      paramList({
        page: this.pageInfo.currentPage,
        size: this.pageInfo.limit
      }).then(res => {
        if (res && res.code == 0) {
          console.log(res.data.items)
          this.list = sortDataList(res.data.items, this.pageInfo.currentPage)
          this.pageInfo.allCount = res.data.total
        }
      })
      this.listLoading = false
    },
    handleSizeChange (val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.getRoleList()
    },
    handleCurrentChange (val) {
      this.pageInfo.currentPage = val
      this.getRoleList()
    },
    add () {
      this.currentData = {}
      this.isShowEdit = true
      this.isedit = false
    },
    editRole (data) {
      this.currentData = data
      this.isShowEdit = true
      this.isedit = true
    },
    closeDialog () {
      this.isShowEdit = false
      this.isShowAdd = false
      this.isedit = false
    },
    delet (data) {
      this.$confirm('您确认删除吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteParam({
          ids: data
        }).then(res => {
          this.$message.success('删除成功')
          this.getRoleList()
        })
      }).catch(() => { })
    },
    emptyDeal (_val) {
      return emptyTrans(_val)
    },
    // 业务类型
    businessStatus (_val) {
      return statusTrans(_val, this.businessList)
    },
    // 显示操作按钮
    operateShow (row, column, cell, event) {
      event.path[1].cells[4].children[0].children[0].style.display = 'block'
    },
    operateClose () {
      event.path[1].cells[4].children[0].children[0].style.display = 'none'
    }
  }
}
</script>
<style lang="scss" scoped>
.operate {
  float: right;
  height: 24px;
}
[class^="el-icon-"] {
  margin-left: 18px;
  font-size: 20px;
}
.title {
  text-align: left;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
.el-button--primary {
  float: right;
}
.el-table {
  margin-top: 16px;
}
body .app-wrapper-new-style .test-container {
  padding: 16px 24px 100px 24px;
}
[class^="el-icon-"] {
  font-size: 16px;
  // margin-left: 24px;
}
[class^="el-icon-"]:hover {
  color: #ffa940;
}
.mt10 {
  margin-top: 24px !important;
  float: right;
}
.icon {
  display: none;
}
.set {
  margin-right: 24px;
  font-size: 14px;
  color: #ffa940;
  line-height: 30px;
}
.el-button {
  font-size: 14px;
}
.info {
  color: #ffa940;
}
</style>
